module.exports = __webpack_public_path__ + "img/rank-gold.fed170d3.png";